import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import $ from "jquery";
import readXlsxFile from "read-excel-file";
import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";
import { SheetJSFT } from "./types";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";


const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;



const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

const exportToCSV = (csvData,fileName) => {
  
  const Heading = [['City','WH','Brand','Item Code','Desc','Mrp','Inbound Qty','Outbound Qty','Returns','Adjustment']];
  const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'csv', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}

const exportToCSVProduct = (e,csvData,fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [["Product Code"]];
 
  const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}

const exportToCSVBill = (e,csvData,fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [["Bill No."]];
  
  const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchCycleCountData = this.fetchCycleCountData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);


    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      item_code_header: [
        { "Hul Code": "", "Area Code": ""},
      ],
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no : "",
      trip_id : "",
      product_code : "",

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      from_date: "",
      to_date: "",
      mrp : "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData : [],
      batch_id : "",
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  /*FromDateChange = date => {
    this.setState({
      from_date: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }


  }

  ToDateChange = date => {

    this.setState({
      to_date: date,
      showToErr: false
    })
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        to_date: "",

      })
      to_Date_val = ""
    }

  }
*/
  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });

    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };

  handleChange1(evt) {
    const files = evt.target.files;
    var file1 = evt.target.value;
    this.setState(
      {
        btnDisabled: true,
        loading_overlay: true,
      },
      () => {
        if (files && files[0]) {
          this.setState({
            file: files[0],
          });
        } else {
          this.setState({
            loading_overlay: false,
            btnDisabled: false,
            file: {},
          });
          $(".upload_success").css("display", "none");
          $(".upload_error").css("display", "none");
          $(".button_enable").removeAttr("disabled", "disabled");
          return false;
        }

        var fileArray1 = file1.split(".");
        var extension1 = fileArray1[fileArray1.length - 1];

        if (document.getElementById("my_file_input") !== null) {
          document.getElementById("my_file_input").style.color = "";
          document.getElementById("my_file_input").style.width = "85%";
          document.getElementById("picking_label").style.display = "none";
        } else {
          document.getElementById("my_file_input").style.width = "26%";
        }

        if (
          extension1 != "xlsx" &&
          extension1 != "csv" &&
          extension1 != "xls"
        ) {
          $(".upload_error").css("display", "block");
          $(".upload_success").css("display", "none");
        } else {
          $(".upload_success").css("display", "block");
          $(".upload_error").css("display", "none");
          $(".button_enable").removeAttr("disabled", "disabled");
        }

        this.setState({
          btnDisabled: false,
          loading_overlay: false,
        });
      }
    );
  }

  handleChange2(evt) {
    const files = evt.target.files;
    var file1 = evt.target.value;
    this.setState(
      {
        btnDisabled: true,
        loading_overlay: true,
      },
      () => {
        if (files && files[0]) {
          this.setState({
            file: files[0],
          });
        } else {
          this.setState({
            loading_overlay: false,
            btnDisabled: false,
            file: {},
          });
          $(".upload_success1").css("display", "none");
          $(".upload_error1").css("display", "none");
          $(".button_enable1").removeAttr("disabled", "disabled");
          return false;
        }

        var fileArray1 = file1.split(".");
        var extension1 = fileArray1[fileArray1.length - 1];

        if (document.getElementById("my_file_input1") !== null) {
          document.getElementById("my_file_input1").style.color = "";
          document.getElementById("my_file_input1").style.width = "85%";
          document.getElementById("picking_label1").style.display = "none";
        } else {
          document.getElementById("my_file_input1").style.width = "26%";
        }

        if (
          extension1 != "xlsx" &&
          extension1 != "csv" &&
          extension1 != "xls"
        ) {
          $(".upload_error1").css("display", "block");
          $(".upload_success1").css("display", "none");
        } else {
          $(".upload_success1").css("display", "block");
          $(".upload_error1").css("display", "none");
          $(".button_enable1").removeAttr("disabled", "disabled");
        }

        this.setState({
          btnDisabled: false,
          loading_overlay: false,
        });
      }
    );
  }

  handleChangeItem = (evt)=>{
    const files = evt.target.files;
    var file1 = evt.target.value;
    this.setState(
      {
        btnDisabled: true,
        loading_overlay: true,
      },
      () => {
        if (files && files[0]) {
          this.setState({
            file: files[0],
          });
        } else {
          this.setState({
            loading_overlay: false,
            btnDisabled: false,
            file: {},
          });
          $(".upload_success").css("display", "none");
          $(".upload_error").css("display", "none");
          $(".item_button_enable").removeAttr("disabled", "disabled");
          return false;
        }

        var fileArray1 = file1.split(".");
        var extension1 = fileArray1[fileArray1.length - 1];

        if (document.getElementById("item_code") !== null) {
          document.getElementById("item_code").style.color = "";
          document.getElementById("item_code").style.width = "85%";
          document.getElementById("item_label").style.display = "none";
        } else {
          //document.getElementById("item_code").style.width = "26%";
        }

        if (
          extension1 != "xlsx" &&
          extension1 != "csv" &&
          extension1 != "xls"
        ) {
          $(".upload_error").css("display", "block");
          $(".upload_success").css("display", "none");
        } else {
          $(".upload_success").css("display", "block");
          $(".upload_error").css("display", "none");
          $(".item_button_enable").removeAttr("disabled", "disabled");
        }

        this.setState({
          btnDisabled: false,
          loading_overlay: false,
        });
      }
    );

  }


  onMrpChange = (evt) => {
    this.setState({
      mrp : evt.target.value,
    });
  };
  
  onProductChange = (evt) => {
    this.setState({
      product_code : evt.target.value,
    });
  };
  onBatchChange = (evt)=>{
    this.setState({
      batch_id : evt.target.value,
    })
  }

  handleChangeEvent = (evt) =>{
    this.setState({[evt.target.name]: evt.target.value})

  }

  fetchCycleCountData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    var formData = new FormData();
    if(From_Date_val !== undefined){
      formData.append('fromdate', From_Date_val);
    }

    if(to_Date_val !== undefined){
      formData.append('todate', to_Date_val);
    }
    //formData.append('bill_no', document.getElementById('bill_no').files[0]); 
    if($('#my_file_input1')[0].files[0] !== undefined){
      formData.append('bill_no', $('#my_file_input1')[0].files[0]);
    }
    if($('#my_file_input')[0].files[0] !== undefined){
      formData.append('item_code', $('#my_file_input')[0].files[0]); 
    }
    if(this.state.city !== undefined){
      formData.append('city', this.state.city); 
    }
    if(this.state.brand !== undefined){
      formData.append('brand', this.state.brand);
    }
    if(this.state.warehouse !== undefined){
      formData.append('warehouse', this.state.warehouse);
    }

    if(this.state.product_code !== undefined){
      formData.append('product_code', this.state.product_code);
    }

     if(this.state.product_code !== undefined){
      formData.append('mrp', this.state.mrp);
    }


  
    
    
    

    const payload = {
      fromdate: From_Date_val,
      todate: to_Date_val,
      city : this.state.city,
      brand : this.state.brand,
      warehouse : this.state.warehouse,
    };
    API.post('/mis/itemTransactionReport', { param: formData })
      .then(response => response.data)

      .then(data => {

        this.setState({ tableRows: this.assemblePosts(data),orderData : data})

      })

      .then(async () => {

        this.setState({  isLoading: false ,loading_overlay: false})

       

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
          city: post.city,
          warehouse: post.WH,
          brand : post.Brand,
          item_code: post['Item Code'],
          desc: post['Item Description'],
          mrp : post.MRP,
          inbound_qty : post['Inbound Qty'], 
          outbound_qty: post['Outbound Qty'],
          return_qty: post['Return Qty'],  
          adjustment_qty: post['Adjustment Qty'],  
          

        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      filtered_orderData : posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {

    const data = {

      columns: [
        {
          label: ' City',
          field: 'city',
          sort: 'asc',
          width: 130,

        },
        {
          label: 'WH',
          field: 'warehouse',
          sort: 'asc',
          width: 120,

        },
        {
          label: 'Brand',
          field: 'brand',
          sort: 'asc',
          width: 120,

        },
        {

          label: 'Item Code',
          field: 'item_code',
          width: 140,
          sort: 'asc',

        }, 
        {
          label: 'Desc',
          field: 'desc',
          sort: 'asc',
          width: 150,

        },

        {
          label: 'Mrp',
          field: 'mrp',
          width: 140,
          sort: 'asc',

        },
        {

          label: 'Inbound Qty',
          field: 'inbound_qty',
          width: 140,
          sort: 'asc',

        },

        {
          label: 'Outbound Qty',
          field: 'outbound_qty',
          width: 140,
          sort: 'asc',

        },
   

        {

          label: 'Returns',
          field: 'return_qty',
          width: 140,
          sort: 'asc',

        },

        {

          label: 'Adjustment',
          field: 'adjustment_qty',
          width: 140,
          sort: 'asc',

        },

        

       

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <CardBody style={{ paddingTop: 22, paddingBottom: 15, marginTop : "-20px",paddingBottom: 0 }}>
          <form className="form" >

            <div style={{ width: '14%', marginBottom: '0px', float: 'left', marginRight: 5 }}>

              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="From Date"
                format='yyyy-MM-dd'

              />

              {this.state.showFromErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
              }
              {this.state.dateOrderError && (
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                )}
            </div>

            <div style={{ width: '14%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
              <DatePicker
                selected={this.state.to_date}
                onChange={this.ToDateChange}
                className="ledger_todate"
                placeholderText="To Date"
              />
              {this.state.showToErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
              }

               {this.state.dateRangeError &&
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                }

            </div>
            <div
                style={{width:'11%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
                <div
                  className="form__form-group-field"
                   
                >
                   <input type = "text" style={{height: 38}} name="city" className="form-control" placeholder= "City" onChange={this.handleChangeEvent}/>
                </div>
              </div>
            <div
                style={{width:'11%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
                <div
                  className="form__form-group-field"
                   
                >
                   <input type = "text" style={{height: 38}} className="form-control" name="brand" placeholder= "Brand" onChange={this.handleChangeEvent}/>
                </div>
              </div>
            <div
                style={{width:'11%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
                <div
                  className="form__form-group-field"
                   
                >
                   <input type = "text" style={{height: 38}} className="form-control" name="warehouse" placeholder= "Warehouse" onChange={this.handleChangeEvent}/>
                </div>
              </div>
               <div
                style={{width:'11%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
                <div
                  className="form__form-group-field"
                   
                >
                   <input type = "text" style={{height: 38}} className="form-control" name="product_code" placeholder= "Product Code" onChange={this.handleChangeEvent}/>
                </div>
              </div>
               <div
                style={{width:'11%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
                <div
                  className="form__form-group-field"
                   
                >
                   <input type = "text" style={{height: 38}} className="form-control" name="mrp" placeholder= "MRP" onChange={this.handleChangeEvent}/>
                </div>
              </div>

              <div
                style={{width:'32%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
              <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              <div>
              <div
                    
                    style={{ border: "1px solid #f2f4f7", marginTop: 4, }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"
                      id="my_file_input"
                      onChange={this.handleChange1}
                      ref={(ref) => (this.fileInput = ref)}
                    />
                    <label for="files" id="picking_label">
                      Select and Upload Item
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                  </div>
                  <br/>
                   <button
                  color="primary"
                  className="download_sample_styling item_button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVProduct(e,
                      this.state.item_code_header,
                      "item_code_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                </form>

                  </div>


                  <div
                style={{width:'32%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
              <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              <div>
              <div
                    
                    style={{ border: "1px solid #f2f4f7", marginTop: 4, }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"
                      id="my_file_input1"
                      onChange={this.handleChange2}
                      ref={(ref) => (this.fileInput1 = ref)}
                    />
                    <label for="files" id="picking_label1">
                      Select and Upload Bill No
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error1"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success1"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                  </div>
                    <br/>
                   <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVBill(e,
                      this.state.item_code_header,
                      "Bill_no_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                </form>
                  </div>
              

            <div style={{ width: '8%', marginBottom: '0px', marginLeft: "60px", float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                    marginTop: 6
                  }}
                  id="button_enable"
                  onClick={() => this.fetchCycleCountData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
              </ButtonToolbar>
            </div>
            <div style={{ width: '3%', marginBottom: '0px', float: 'left' }}>
              <Button type="button" className="btn btn-primary-outline"
                style={{
                  cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                  backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                }}
                id="button_enable"
                // onClick={this.downloadReport}
              >

                {/* <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} /> */}
                <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, "Item Wise Transaction Report")} />
              </Button>
            </div>
            

          </form>
          </CardBody>
          {
            this.state.showFetchBinData && (

              <CardBody style={{ marginTop: 5 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">Reports</h4>

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={data}
                  // style={{ textAlign: "center" }}
                />
              </CardBody>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));